import { IRawQueryParamsProps } from "@faire/web/common/query-params/IQueryParamsProps";
import { lazy } from "react";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export interface IProps extends IRawQueryParamsProps {
  onClose?: () => void;
}

export const LazyMobileMenu = lazy(() =>
  import(/* webpackChunkName: "retailer-mobile-menu" */ "./MobileMenu")
    .then((m) => ({ default: m.MobileMenu }))
    .catch(handleComponentLoadError)
);
